<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-03-31 09:13:34
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-07-09 08:46:15
 * @Description: 信息价格
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/dialog/informationPriceDialog.vue
-->
<template>
  <el-dialog :visible.sync="informationPriceDialog" width="1500px" :close-on-click-modal="false" :before-close="close">
    <span slot="title" class="dialog-title">信息价格配置</span>
    <div class="dialoginfo">
      <div
        style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 10px">
        <div>生效时间: {{ data.effectiveTime || "-" }}</div>
        <!-- <el-button class="bottom_all" style="margin-right: 24px" @click="infoDialog = true">信息调价</el-button> -->
      </div>
      <div style="height: 700px; overflow-y: auto">
        <!-- 第一部分 -->
        <el-table ref="table" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
          stripe style="width: 100%; margin-top: 20px" :data="fromDate[0].priceDetails" tooltip-effect="dark"
          :span-method="objectSpanMethod">
          <el-table-column align="center" label="强度等级">
            <el-table-column align="center" label="泵送">
              <!-- <el-table-column align="center" label="生效日期" prop="startTime" width="200"></el-table-column> -->
              <el-table-column align="center" label="砼单价" prop="startTime" min-width="150">
                <el-select v-model="fromDate[0].concretePriceMethod" :disabled="isLook" placeholder="请选择"
                  @change="changeConcretePriceMethod">
                  <el-option :key="1" label="按C30信息价" :value="1"> </el-option>
                  <el-option :key="2" label="按标号信息价" :value="2"> </el-option>
                  <el-option :key="3" label="按砌筑砂浆M5" :value="3"> </el-option>
                </el-select>
              </el-table-column>
              <el-table-column align="center" label="城市" prop="startTime" width="200">
                <!-- <el-cascader ref="address" v-model="scope.row.areaCode0" style="width: 150px" :options="treeData" filterable @change="administrativeDistrictsFun()"></el-cascader> -->
                <el-select ref="cityCode" v-model="fromDate[0].cityCode" :disabled="isLook" placeholder="请选择" @change="
                  $nextTick(() => {
                    fromDate[0].cityName = $refs.cityCode.selectedLabel;
                    selectCity(fromDate[0].cityCode);
                  })
                  ">
                  <el-option :key="1" label="成都" value="chendu"> </el-option>
                  <el-option :key="2" label="重庆" value="chongqing"> </el-option>
                  <el-option :key="3" label="绵竹" value="mianzhu"> </el-option>
                  <el-option :key="4" label="遂宁" value="suining"> </el-option>
                  <el-option :key="5" label="资阳" value="ziyang"> </el-option>
                  <el-option :key="6" label="德阳" value="deyang"> </el-option>
                  <el-option :key="7" label="眉山" value="meishan"> </el-option>
                  <el-option :key="8" label="宜宾" value="yibin"> </el-option>
                  <el-option :key="9" label="内江" value="neijiang"> </el-option>
                  <el-option :key="10" label="西昌" value="xichang"> </el-option>
                  <el-option :key="11" label="绵阳" value="mianyang"> </el-option>
                  <el-option :key="12" label="广安" value="guangan"> </el-option>
                  <el-option :key="13" label="达州" value="dazhou"> </el-option>
                  <el-option :key="14" label="南充" value="nanchong"> </el-option>
                  <el-option :key="15" label="乐山" value="leshan"> </el-option>
                </el-select>
              </el-table-column>
              <el-table-column align="center" label="行政区" prop="startTime" width="200">
                <el-select ref="areaId" v-model="fromDate[0].areaId" :disabled="isLook" placeholder="请选择" clearable
                  @change="
                    $nextTick(() => {
                      fromDate[0].areaName = $refs.areaId.selectedLabel;
                    })
                    ">
                  <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-table-column>
              <el-table-column align="center" label="对应关系" prop="startTime" width="700">
                
                信息价对应
                <el-select v-model="fromDate[0].correspondingOption" :disabled="isLook" size="mini" placeholder="请选择"
                  style="width: 120px">
                  <el-option :key="1" label="当期对当月" :value="1"> </el-option>
                  <el-option :key="0" label="合同指定月" :value="2"> </el-option>
                </el-select>
                结算月信息价
                <el-select v-model="fromDate[0].monthlySettlementPriceType" size="mini" style="width:120px" :disabled="isLook" placeholder="请选择">
                  <el-option :key="1" label="信息价" :value="1" :disabled="fromDate[0].correspondingOption == 2"> </el-option>
                  <el-option :key="2" label="信息价加权平均" :value="2"> </el-option>
                </el-select>
                <span v-if="fromDate[0].correspondingOption != 1">
                当月对应
                <el-select v-model="fromDate[0].correspondence" :disabled="isLook" size="mini" placeholder="请选择"
                  style="width: 100px">
                  <el-option :key="0" label="当月" :value="0"> </el-option>
                  <el-option :key="1" label="上一月" :value="1"> </el-option>
                  <el-option :key="2" label="上二月" :value="2"> </el-option>
                  <el-option :key="3" label="上三月" :value="3"> </el-option>
                  <el-option :key="4" label="上四月" :value="4"> </el-option>
                  <el-option :key="5" label="上五月" :value="5"> </el-option>
                  <el-option :key="6" label="上六月" :value="6"> </el-option>
                  <el-option :key="7" label="上七月" :value="7"> </el-option>
                  <el-option :key="8" label="上八月" :value="8"> </el-option>
                  <el-option :key="9" label="上九月" :value="9"> </el-option>
                  <el-option :key="10" label="上十月" :value="10"> </el-option>
                  <el-option :key="11" label="上十一月" :value="11"> </el-option>
                  <el-option :key="12" label="上十二月" :value="12"> </el-option>
                  <!-- <el-option :key="20" label="年平均" :value="20"> </el-option> -->
                </el-select>
                信息价
                </span>
              </el-table-column>
              <el-table-column align="center" label="标号">
                <template slot-scope="scope">
                  <span v-if="(scope.row.strenghGrade == 'C30' && fromDate[0].concretePriceMethod == 1)||(scope.row.strenghGrade == '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3)"
                    style="color:red">{{ scope.row.strenghGrade }}</span>
                  <span v-else>{{ scope.row.strenghGrade }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="价格方式" prop="startTime" width="160">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.pumpingPriceMode" :disabled="isLook" placeholder="请选择"
                    @change="sameValue('pumpingPriceMode', scope.row.pumpingPriceMode, scope.row, 1, scope.$index)">
                    <el-option
                      v-if="(fromDate[0].concretePriceMethod == 1 && scope.row.strenghGrade == 'C30') || fromDate[0].concretePriceMethod == 2||(scope.row.strenghGrade == '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3)"
                      :key="1" label="按信息价比例" :value="1"> </el-option>
                    <el-option
                      v-if="(fromDate[0].concretePriceMethod == 1 && scope.row.strenghGrade == 'C30') || fromDate[0].concretePriceMethod == 2||(scope.row.strenghGrade == '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3)"
                      :key="2" label="按信息价固定金额" :value="2"> </el-option>
                    <el-option v-if="scope.row.strenghGrade !== 'C30' && fromDate[0].concretePriceMethod == 1" :key="3"
                      label="按C30比例" :value="3"> </el-option>
                    <el-option v-if="scope.row.strenghGrade !== 'C30' && fromDate[0].concretePriceMethod == 1" :key="4"
                      label="按C30固定金额" :value="4"> </el-option>
                      <el-option v-if="scope.row.strenghGrade !== '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3" :key="5"
                      label="按砌筑砂浆M5比例" :value="3"> </el-option>
                    <el-option v-if="scope.row.strenghGrade !== '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3" :key="6"
                      label="按砌筑砂浆M5固定金额" :value="4"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="浮动" prop="startTime" width="120">.
                <template slot-scope="scope">
                  <el-select v-model="scope.row.pumpingFloat" :disabled="isLook" placeholder="请选择">
                    <el-option :key="1" label="上浮" :value="1"> </el-option>
                    <el-option :key="2" label="下浮" :value="2"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="调整情况(含税)" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.pumpingAdjustBase" :disabled="isLook" type="Number" style="width: 100%" @mousewheel.native.prevent>
                    <template slot="append">{{ scope.row.pumpingPriceMode == 1 || scope.row.pumpingPriceMode == 3 ? "%" :
                      "元" }}</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="固定金额(含税)" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.pumpOtherFixed" :disabled="isLook" type="Number" style="width: 100%" @mousewheel.native.prevent>
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="非泵送（在泵送基础上进行调整）">
              <el-table-column align="center" label="价格方式" prop="startTime" width="160">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.nonPumpingPriceMode" :disabled="isLook" placeholder="请选择"
                    @change="sameValue('nonPumpingPriceMode', scope.row.nonPumpingPriceMode, scope.row, 1, scope.$index)">
                    <el-option
                      v-if="(fromDate[0].concretePriceMethod == 1 && scope.row.strenghGrade == 'C30') || fromDate[0].concretePriceMethod == 2 ||(scope.row.strenghGrade == '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3)"
                      :key="1" label="按信息价比例" :value="1"> </el-option>
                    <el-option
                      v-if="(fromDate[0].concretePriceMethod == 1 && scope.row.strenghGrade == 'C30') || fromDate[0].concretePriceMethod == 2 ||(scope.row.strenghGrade == '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3)"
                      :key="2" label="按信息价固定金额" :value="2"> </el-option>
                    <el-option v-if="scope.row.strenghGrade !== 'C30' && fromDate[0].concretePriceMethod == 1 " :key="3"
                      label="按C30比例" :value="3"> </el-option>
                    <el-option v-if="scope.row.strenghGrade !== 'C30' && fromDate[0].concretePriceMethod == 1" :key="4"
                      label="按C30固定金额" :value="4"> </el-option>
                    <el-option v-if="scope.row.strenghGrade !== 'C30' && fromDate[0].concretePriceMethod == 1" :key="4"
                      label="按C30固定金额" :value="4"> </el-option>
                    <el-option v-if="scope.row.strenghGrade !== '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3" :key="5"
                      label="按砌筑砂浆M5比例" :value="3"> </el-option>
                    <el-option v-if="scope.row.strenghGrade !== '砌筑砂浆M5' && fromDate[0].concretePriceMethod == 3" :key="6"
                      label="按砌筑砂浆M5固定金额" :value="4"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="浮动" prop="startTime" width="120">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.nonPumpingFloat" :disabled="isLook" placeholder="请选择">
                    <el-option :key="1" label="上浮" :value="1"> </el-option>
                    <el-option :key="2" label="下浮" :value="2"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="调整情况(含税)" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.nonPumpingAdjustBase" :disabled="isLook" type="Number" style="width: 100%" @mousewheel.native.prevent>
                    <template slot="append">{{ scope.row.nonPumpingPriceMode == 1 || scope.row.nonPumpingPriceMode == 3 ?
                      "%" : "元" }}</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="固定金额(含税)" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.otherFixed" :disabled="isLook" type="Number" style="width: 100%" @mousewheel.native.prevent>
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
            </el-table-column>
            <!-- <el-table-column align="center" label="操作" width="80">
                        <template slot-scope="scope">
                        <el-button size="mini" class="bottom_two" @click="deletePriceInfo(scope.row, scope.$index)"> 删除 </el-button>
                        </template>
                    </el-table-column> -->
          </el-table-column>
        </el-table>
        <!-- 第二部分 - 性能等级 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%; margin-top: 20px" :data="mainDate.performanceGrade" tooltip-effect="dark">
          <el-table-column align="center" label="性能等级" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input v-model="scope.row.priceIncludinTax" :disabled="isLook" type="Number" style="width: 200px"
                placeholder="请输入" @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 第三部分 - 特殊要求 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%; margin-top: 20px" :data="mainDate.specialRequirements" tooltip-effect="dark">
          <el-table-column align="center" label="特殊要求" prop="startTime" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input v-model="scope.row.priceIncludinTax" :disabled="isLook" type="Number" style="width: 200px"
                placeholder="请输入" @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 第三部分 - 外加剂要求 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%; margin-top: 20px" :data="mainDate.admixtureRequirements" tooltip-effect="dark">
          <el-table-column align="center" label="外加剂要求" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input v-model="scope.row.priceIncludinTax" :disabled="isLook" type="Number" style="width: 200px"
                placeholder="请输入" @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 第三部分 - 材料要求 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%; margin-top: 20px" :data="mainDate.meterialRequirements" tooltip-effect="dark">
          <el-table-column align="center" label="材料要求" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input v-model="scope.row.priceIncludinTax" :disabled="isLook" type="Number" style="width: 200px"
                placeholder="请输入" @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 其他要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="mainDate.otherRequirements" tooltip-effect="dark">
          <el-table-column prop="askName" label="其他要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 200px"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
        <!-- 第四部分 - 组合 -->
        <div style="margin-top: 10px">
          <el-button v-if="!isLook" class="bottom_all_two" style="margin-right: 24px"
            @click="addProductComposePriceDig = true">添加其它组合</el-button>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
            style="width: 100%; margin-top: 20px" :data="productComposePriceList" tooltip-effect="dark">
            <el-table-column align="center" label="材料要求" prop="productName" width="auto"> </el-table-column>
            <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.priceIncludinTax" :disabled="isLook" type="Number" style="width: 200px"
                  placeholder="请输入" @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                  @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" label="不含税价格" prop="priceExcludingTax" width="auto">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" width="auto" align="center">
              <template slot-scope="scope">
                <el-link v-if="!isLook" type="danger" :underline="false"
                  @click="deleteProductComposePrice(scope.$index)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 第五部分 - 特殊产品 -->
        <div style="margin-top: 10px">
          <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%"
            :data="tableData_other" tooltip-effect="dark">
            <el-table-column v-for="(item, index) in table_other" :key="index" :prop="item.prop" :label="item.label"
              :width="item.width" align="center" :fixed="item.label == '操作' ? 'right' : false">
              <template slot-scope="scope">
                <span v-if="item.label == '费用标准'">
                  <el-select v-model="scope.row.costStandard" :disabled="isLook" placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in table_other_options" :key="item.value" :label="item.label"
                      :value="item.value"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '含税价格'">
                  <el-input v-model="scope.row.priceIncludinTax" :disabled="isLook" type="Number" style="width: 200px"
                    @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                    @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent>
                  </el-input>
                </span>
                <span v-else-if="item.label == '不含税价格'">
                  <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
                </span>
                <span v-else>{{ scope.row[item.prop] || "*" }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 第六部分 - 同比例砂浆-->
        <div>
          <div
            style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; margin-top: 10px">
            <div>同比例砂浆：</div>
            <el-select v-model="mortar.strengthGradeId" disabled placeholder="请选择" style="width: 120px">
              <el-option v-for="item in [{ id: '0001', name: '相同强度' }, ...config_options.strengthGrade]" :key="item.id"
                :label="item.name" :value="item.id" @click.native="selectMortarFun(item)"> </el-option>
            </el-select>
            <div style="margin-left: 10px">类型：</div>
            <el-select v-model="mortar.type" :disabled="isLook" placeholder="请选择" style="width: 120px">
              <el-option key="1" label="倍数" :value="1"> </el-option>
              <el-option key="2" label="固定金额" :value="2"> </el-option>
            </el-select>
            <div style="margin-left: 10px">{{ mortar.type == 2 ? "固定金额:" : "倍数:" }}</div>
            <el-input v-model="mortar.multiple" :disabled="isLook" style="width: 140px" placeholder="请输入内容"> </el-input>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: flex-start; margin-top: 10px">
            <div style="margin-right: 10px">上传附件:</div>
            <FileComponent2 style="width: 600px" fileCode="priceFile" :files="files" @deleteFile="deleteFile"
              @uplodeSuccess="uplodeSuccess" />
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">取 消</el-button>
      <el-button v-if="!isLook" class="bottom_all" style="margin-left: 24px" @click="save()">确 定</el-button>
    </span>
    <!-- 信息调价 -->
    <InformationSetPriceDialog :infoDialog.sync="infoDialog" :engineeringId="data.engineeringId" :infoId="data.id"
      @refInfoPriceDialog="queryInfoReadjustCostDetailFun" @closeInformationSetPriceDialog="infoDialog = false" />
    <!-- 添加组合类型 -->
    <el-dialog v-dialogDrag :visible.sync="addProductComposePriceDig" width="680px" :append-to-body="true"
      :close-on-click-modal="false" :before-close="closeProductComposePrice">
      <span slot="title" class="dialog-title">添加组合</span>
      <div class="dialoginfo">
        <el-form :model="ProductComposePriceForm" class="demo-form" label-width="auto">
          <el-form-item label="强度等级：">
            <el-select ref="strengthGrade" v-model="ProductComposePriceForm.strengthGrade" value-key="name"
              placeholder="请选择">
              <el-option v-for="item in config_options.strengthGrade" :key="item.name" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性能等级：">
            <el-select ref="function" v-model="ProductComposePriceForm.function" value-key="name" multiple
              placeholder="请选择">
              <el-option v-for="item in config_options.performanceGrade" :key="item.name" :label="item.name"
                :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材料要求：">
            <el-select ref="material" v-model="ProductComposePriceForm.material" value-key="name" multiple
              placeholder="请选择">
              <el-option v-for="item in config_options.meterialRequirements" :key="item.name" :label="item.name"
                :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="特殊要求：">
            <el-select ref="special" v-model="ProductComposePriceForm.special" value-key="name" multiple
              placeholder="请选择">
              <el-option v-for="item in config_options.specialRequirements" :key="item.name" :label="item.name"
                :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外加剂要求：">
            <el-select ref="admixture" v-model="ProductComposePriceForm.admixture" value-key="name" multiple
              placeholder="请选择">
              <el-option v-for="item in config_options.admixtureRequirements" :key="item.name" :label="item.name"
                :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他要求：">
            <el-select ref="other" v-model="ProductComposePriceForm.other" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in config_options.otherRequirements" :key="item.name" :label="item.name"
                :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeProductComposePrice()">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="addProductComposePrice()">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { queryDisclose, queryInfoReadjustCostDetail, updatePrising, saveOrUpdateInfoConsultPrice, queryPatternList } from "@/api/internetSales/engineeringControl.js";
import InformationSetPriceDialog from "./informationSetPriceDialog.vue";
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import { updateStatus } from "@/api/internetSales/engineeringControl.js";

export default {
  components: {
    InformationSetPriceDialog,
    FileComponent2,
  },
  props: {
    informationPriceDialog: {
      type: Boolean,
      default: false,
    },
    isLook: {
      type: Boolean,
      default: false,
    },
    data: {
      effectiveTime: "",
    },
    engineeringInfo: {
      type: Object,
      default: new Object(),
    },
  },
  watch: {
    informationPriceDialog(value) {
      if (value) {
        this.queryInfoReadjustCostDetailFun();
        this.queryDiscloseFun();
      }
    },
  },
  data() {
    return {
      fromDate: [
        {
          cityCode: "",
          cityName: "",
          areaid: "", //区县编号
          areaName: [],
          concretePriceMethod: 2, //砼单价，1按c30信息价，2按信息价
          correspondingOption: "",//信息价对应关系：1.当期对当月；2.合同指定月
          correspondence: "", //对应关系:0当期；1上一月；2上二月；3上三月；4上四月；5上五月；6上六月；7上七月；8上八月；9上九月；10上十月；11上十一月；12上十二月；20年平均
          enclosureUrl: "", //附件url
          engineeringId: "", //工程id
          priceDetails: [
            {
              nonPumpingAdjustBase: 0, //(非泵送)调整情况
              nonPumpingFloat: "", //(非泵送)浮动：1上浮；2下浮
              nonPumpingPriceMode: "", //(非泵送)价格方式：1按比例；2按固定金额
              pumpingAdjustBase: 0, //(泵送)调整情况
              pumpingFloat: "", //(泵送)浮动：1上浮；2下浮
              pumpingPriceMode: "", //(泵送)价格方式：1按比例；2按固定金额
              strenghGrade: "", //强度等级
            },
          ],
          startTime: "", //生效时间
        },
      ],
      mainDate: {
        strengthGrade: [],
        performanceGrade: [],
        meterialRequirements: [],
        otherRequirements: [],
        admixtureRequirements: [],
        specialRequirements: [],
      },
      tableData_other: [],
      table_other: [
        { label: "特殊产品", width: "auto", prop: "productName", status: true },
        { label: "费用标准", width: "auto", prop: "costStandard", status: true },
        { label: "含税价格", width: "auto", prop: "priceIncludinTax", status: true },
        { label: "不含税价格", width: "auto", prop: "priceExcludingTax", status: true },
      ],
      table_other_options: [
        { value: 1, label: "按车收费" },
        { value: 0, label: "不收费" },
        { value: 2, label: "按方量收费" },
      ],
      config_options: {
        strengthGrade: [],
        performanceGrade: [],
        meterialRequirements: [],
        otherRequirements: [],
        admixtureRequirements: [],
        specialRequirements: [],
      },
      mortar: {
        multiple: 0,
        type: 1,
        strengthGradeId: "0001",
        strengthGrade: "相同强度",
      },
      files: [],
      addProductComposePriceDig: false,
      ProductComposePriceForm: {
        function: [],
        material: [],
        special: [],
        admixture: [],
        other: [],
        strengthGrade: {},
      },
      productComposePriceList: [], //组合类型
      infoDialog: false,
      areaList: [],
    };
  },
  methods: {
    changeConcretePriceMethod() {
      this.$nextTick(() => {
        this.fromDate[0].priceDetails.forEach(item => {
          item['pumpingPriceMode'] = '';
          item['nonPumpingPriceMode'] = '';
        });
      })
    },
    sameValue(key, value, row, type, index) { //type 为1 按照C30分类复制  type为 2不判断
      //如果砼单价为C30信息价  C30只修改C30 其余标号还是整体修改
      if (this.fromDate[0].concretePriceMethod == 1 && type == 1) {
        if (row.strenghGrade == 'C30') {
          this.fromDate[0].priceDetails[index][key] = value
        } else {
          this.fromDate[0].priceDetails.forEach(item => {
            if (item.strenghGrade !== 'C30') {
              item[key] = value;
            }
          });
        }
      } else if (this.fromDate[0].concretePriceMethod == 3 && type == 1) {         
      // type 为1 按照砌筑砂浆M5分类复制  type为 2不判断如果砼单价为砌筑砂浆M5  砌筑砂浆M5只修改砌筑砂浆M5 其余标号还是整体修改
        if (row.strenghGrade == '砌筑砂浆M5') {
          this.fromDate[0].priceDetails[index][key] = value
        } else {
          this.fromDate[0].priceDetails.forEach(item => {
            if (item.strenghGrade !== '砌筑砂浆M5') {
              item[key] = value;
            }
          });
        }
      }else {
        this.fromDate[0].priceDetails.forEach(item => {
          item[key] = value;
        });
      }

    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
        if (rowIndex == 0) {
          return {
            rowspan: this.fromDate[0].priceDetails.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    freshValue(event, code, row) {
      this.$set(row, code, event);
    },
    //选择城市获取区域
    selectCity(cityCode) {
      queryPatternList({ informationPriceType: 1, cityDode: cityCode }).then(res => {
        if (res.code == 1001) {
          this.areaList = res.data.areaList;
        }
      });
    },
    deletePriceInfo(row, index) {
      updatePrising({
        id: row.id,
      }).then(res => {
        if (res.code == 1001) {
          this.fromDate.splice(index, 1);
        }
      });
    },
    priceExcludingTaxFun(val) {
      val.priceExcludingTax = ((val.priceIncludinTax * 1) / (1 + this.data.taxRate * 1)).toFixed(2);
    },
    priceIncludinTaxFun(val) {
      val.priceIncludinTax = ((val.priceExcludingTax * 1) * (1 + this.data.taxRate * 1)).toFixed(2);
    }, 
    selectMortarFun(val) {
      this.mortar.strengthGrade = val.name;
      this.mortar.strengthGradeId = val.id;
    },
    close() {
      this.productComposePriceList = [];
      this.$emit("closeInformationPriceDialog", false);
    },
    save() {
      let productTypesList = this.tableData_other.map(item => {
        return {
          costStandard: item.costStandard,
          priceExcludingTax: item.priceExcludingTax,
          priceIncludinTax: item.priceIncludinTax,
          productId: item.productId,
          productName: item.productName,
        };
      });
      let list = [...(this.mainDate.performanceGrade || []), ...(this.mainDate.meterialRequirements || []), ...(this.mainDate.specialRequirements || []), ...(this.mainDate.admixtureRequirements || []), ...(this.mainDate.otherRequirements || [])];
      let type = false;
      this.productComposePriceList.forEach(item => {
        if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
          type = true;
        }
      });
      // productTypesList.forEach(item => {
      //     if(item.priceIncludinTax !== 0 && !item.priceIncludinTax){
      //         type = true
      //     }
      //     if(item.costStandard !== 0 && !item.costStandard){
      //         type = true
      //     }
      // })
      list.forEach(item => {
        if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
          type = true;
        }
      });
      if (type) {
        this.$message.warning("表格数据不允许为空!");
        return;
      }
      if (!this.mortar.type || !this.mortar.multiple) {
        this.$message.warning("同比例砂浆数据不允许为空!");
        return;
      }
      let type2 = false;
      let objKey = ["concretePriceMethod", "cityCode", "areaId"];
      let objKey2 = ["pumpingPriceMode", "pumpingFloat", "pumpingAdjustBase", "nonPumpingPriceMode", "nonPumpingFloat", "nonPumpingAdjustBase"];
      objKey.forEach(item => {
        if (!this.fromDate[0][item] && this.fromDate[0][item] != 0) {
          type2 = true;
        }
      });
      this.fromDate[0].priceDetails.forEach(item => {
        objKey2.forEach(item2 => {
          if (!item[item2] && item[item2] != 0) {
            type2 = true;
          }
        });
      });
      if (type2) {
        this.$message.warning("强度等级表格数据不允许为空!");
        return;
      }
      saveOrUpdateInfoConsultPrice({
        readjustPricesResordId: this.data.id,
        appendix: JSON.stringify(this.files),
        priceType: this.data.priceType,
        productComposePriceList: this.productComposePriceList,
        mortar: this.mortar,
        productAskList: list,
        productTypes: productTypesList,
        informationAdjustPrice: this.fromDate[0],
      }).then(res => {
        if (res.code == 1001) {
          this.$message({ message: "保存成功", type: "success" });
          if (this.data.sureMaintain == 0) {
            updateStatus({
              id: this.data.id,
              sureMaintain: 1,
            }).then(() => {
              this.close();
            })
          } else {
            this.close();
            let obj = {
              id: this.data.engineeringId,
              name: this.engineeringInfo.name,
              readjustPricesResordId: this.data.id,
              priceType:this.data.priceType,
              effectiveTime:this.data.effectiveTime,
            }
            this.$router.push({ name: "priceMaintenance_sign", query: { dataContent: JSON.stringify(obj), type: 1 } });
          }
        }
      });
    },
    addProductComposePrice() {
      let askName = "";
      if (
        this.ProductComposePriceForm.function.length == 0 &&
        this.ProductComposePriceForm.material.length == 0 &&
        this.ProductComposePriceForm.special.length == 0 &&
        this.ProductComposePriceForm.other.length == 0 &&
        this.ProductComposePriceForm.admixture.length == 0 &&
        !this.ProductComposePriceForm.strengthGrade.name
      ) {
        this.$message.warning("请选择一项要求再添加！");
        return;
      }
      //顺序:强度等级、性能、材料、特殊、其他、外加剂
      askName = askName + this.ProductComposePriceForm.strengthGrade.name;
      this.ProductComposePriceForm.function.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.material.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.special.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.other.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.admixture.forEach(item => {
        askName = askName + item.name;
      });
      let item = {
        productName: askName,
        admixtureRequirements: JSON.stringify(this.ProductComposePriceForm.admixture),
        meterialRequirements: JSON.stringify(this.ProductComposePriceForm.material),
        otherRequirements: JSON.stringify(this.ProductComposePriceForm.other),
        performanceGrade: JSON.stringify(this.ProductComposePriceForm.function),
        priceExcludingTax: "",
        priceIncludinTax: "",
        specialRequirements: JSON.stringify(this.ProductComposePriceForm.special),
        strengthGrade: this.ProductComposePriceForm.strengthGrade.name,
        strengthGradeId: this.ProductComposePriceForm.strengthGrade.id
      };
      this.productComposePriceList.push(item);
      this.closeProductComposePrice();
    },
    closeProductComposePrice() {
      this.addProductComposePriceDig = false;
      this.ProductComposePriceForm = this.$options.data().ProductComposePriceForm;
    },
    deleteProductComposePrice(index) {
      this.productComposePriceList.splice(index, 1);
    },
    queryInfoReadjustCostDetailFun() {
      queryInfoReadjustCostDetail({ readjustPricesResordId: this.data.id, priceType: this.data.priceType }).then(res => {
        if (res.code == 1001 && res.data) {
          // if(res.data.informationPriceGradeList){
          //     res.data.informationPriceGradeList.forEach(item => {
          //         item["areaCode0"] = item.areaCode ? JSON.parse(item.areaCode) : [];
          //     });
          //     this.fromDate = res.data.informationPriceGradeList;
          //     console.log(this.fromDate);
          // }
          if (res.data.informationAdjustPrice) {
            this.fromDate = [];
            this.fromDate.push(res.data.informationAdjustPrice);
            this.fromDate[0].priceDetails.forEach(item => {
              if (!item.pumpingAdjustBase) {
                item.pumpingAdjustBase = 0;
              }
              if (!item.nonPumpingAdjustBase) {
                item.nonPumpingAdjustBase = 0;
              }
            });
            this.selectCity(res.data.informationAdjustPrice.cityCode);
          } else {
            this.fromDate = this.$options.data().fromDate;
          }
          if (!this.fromDate[0].concretePriceMethod) {
            this.fromDate[0].concretePriceMethod = 2;
          }

          if (res.data.productAskMap) {
            this.mainDate = res.data.productAskMap;
          }
          if (res.data.productTypes) {
            this.tableData_other = res.data.productTypes;
          }
          if (res.data.mortar) {
            this.mortar = res.data.mortar;
            this.mortar.strengthGradeId = "0001";
            this.mortar.strengthGrade = "相同强度";
          }
          if (res.data.productComposePriceList) {
            this.productComposePriceList = res.data.productComposePriceList;
          }
          if (res.data.appendix == "[]") {
            this.files = [];
          } else {
            this.files = JSON.parse(res.data.appendix) || [];
          }
        }
      });
    },
    queryDiscloseFun() {
      queryDisclose({ engId: this.data.engineeringId }).then(res => {
        if (res.code == 1001) {
          this.config_options = res.data;
        }
      });
    },
    deleteFun(index) {
      this.tableData.splice(index, 1);
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    uplodeSuccess(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(params);
    },
  },
};
</script>

<style lang="scss" scoped></style>